import { environment } from '@environments/environment';
//import { Airport } from '@ibe/models';
import { INDRALocationsTranslations } from '@ibe.models/translate.indra.model.lib';

export class INDRABookingStep {
	private _date: Date;
	private _departure: INDRALocationsTranslations;
	private _destination: INDRALocationsTranslations;
	flight_selected = false;
	date_selected = false;
	private _cost: {
		currency: {
			value: number,
			unit: string,
			name: string
		},
		points: number
	};
	private _bound: string;

	constructor(departure: INDRALocationsTranslations, destination: INDRALocationsTranslations, date?: Date,  bound?: string) {
		this._departure = departure;
		this._destination = destination;
		this._bound = bound;
		if (date) {
			this._date = date;
		} else {
			this._date = null;
		}
	}

	get departure() {
		return this._departure;
	}

	set departure(newDeparture: INDRALocationsTranslations) {
		this._departure = newDeparture;
	}

	get destination() {
		return this._destination;
	}

	set destination(newDestination: INDRALocationsTranslations) {
		this._destination = newDestination;
	}

	get date() {
		if (this._date) {
			return this._date;
		} else {
			return null;
		}
	}

	get bound() {
		if (this._bound) {
			return this._bound;
		} else {
			return null;
		}
	}

	set bound(bound: string) {
		this._bound = bound;
	}

	showDate() {
		let date = new Date(this._date);
		if (date) {
			return date.toLocaleDateString(environment.locale, {
				month: 'long',
				day: 'numeric'
			});
		} else {
			return '--/--/----';
		}
	}

	get time() {
		let date = new Date(this._date);
		if (this.flight_selected) {
			return date.toLocaleTimeString(environment.locale, {
				hour: 'numeric',
				minute: 'numeric'
			});
		} else {
			return '--:--';
		}
	}

	set date(value: Date) {
		if (value instanceof Date) {
			const date = new Date(value);
			this._date = date;
		} else {
			this._date = null;
		}
	}

	get done() {
		return !!this._date;
	}

	get codeDestination() {
		return this._destination.code;
	}
	get codeDeparture() {
		return this._departure.code;
	}
	get nameDestination() {
		return this._destination.city;
	}
	get nameDeparture() {
		return this._departure.city;
	}

	toString() {
		return (
			this._departure.code +
			' -> ' +
			this._destination.code +
			' on ' +
			this.date +
			' at ' +
			this.time
		);
	}

	get cost() {
		return this._cost;
	}

	set cost(newCost) {
		this._cost = newCost;
	}
}
